<template>
  <div class="cancelAcc">
    <div class="cancelAcc-tips">
      <p class="title">
        <span class="tips-title">注销账号</span>
        <span class="under_line"></span>
      </p>
    </div>
    <div
      class="cancelAcc_content"
      v-show="!tipPass3"
      :class="{bigerContent:(tipPass1 && !tipPass2)}"
    >
      <span class="cancelAcc_logo"></span>
      <el-form
        ref="cancelAccForm"
        :model="cancelAccForm"
        :rules="cancelAccFormRules"
        class="login-form"
        autocomplete="on"
        @submit.native.prevent
      >
        <div class="change-Part">
          <div class="step1" v-show="tipPass1 && !tipPass2">
            <p class="step1-tips-title">请谨慎注销，注销后</p>
            <div class="step1-tips-content">
              <p>1、此账号不可恢复，您的账户信息、会员特权等将永久删除</p>
              <p>2、您将无法通过原有账号、密码进行登录。包括手机网页端、PC端、环球time客户端</p>
            </div>
            <div class="step1-tips-content">请注意：注销您的环球网账号并不代表该账号注销前的所有账号行为和相关责任得到豁免或减轻。</div>
            <div class="step1-tips-content agreeCancel">
              <i
                class="agree-icon"
                :class="{agreeTrue:agreeCancelBool}"
                @click="agreeCancelBool=!agreeCancelBool"
                ref="agreeCancel"
              ></i>申请注销表示您已确认以上信息，并自愿放弃该账号的所有信息。
            </div>
          </div>
          <div class="step2" v-show="tipPass1 && tipPass2 && !tipPass3">
            <p class="step2-tips">安全校验手机号</p>
            <p class="phone">{{userInfo.mobile | hiddenPhoneNum}}</p>
            <div class="check-phonecode-div">
              <el-form-item class="phone-code" prop="phoneCode">
                <el-input
                  ref="phoneCode"
                  v-model.trim="cancelAccForm.phoneCode"
                  placeholder="验证码"
                  name="phoneCode"
                  @keyup.enter.native="nextFn()"
                  type="tel"
                  maxlength="6"
                />
                <el-button
                  :class="{'is-timing':able}"
                  class="codeBtn"
                  :disabled="able"
                  type="primary"
                  @click="getCode"
                >
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show">{{count}} s</span>
                </el-button>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
      <div class="cancelAcc_control" :class="{beginEdit:!(tipPass1 && tipPass2)}">
        <span
          class="pre-step whiteBtn"
          v-if="tipPass1 && tipPass2"
          :class="{unAble:whiteLikeAble}"
          @click="prevFn()"
        >上一步</span>
        <span class="next-step blueBtn" :class="{unAble:blueLikeAble}" @click="nextFn()">{{prevText}}</span>
      </div>
    </div>
    <div class="step3" v-show="tipPass1 && tipPass2 && tipPass3">
      <span class="success-logo"></span>
      <div class="success-tips">
        <p class="success-title">账号注销成功</p>
        <p class="success-jump">
          <a href="http://www.huanqiu.com" class="backIndex">返回首页</a>
        </p>
        <p class="success-thanks">
          感谢您一直以来对环球网的支持，
          我们江湖再见。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import user from "@/api/user";

export default {
  name: "cancelAcc",
  components: {},
  data() {
    const validatePhoneCode = (rule, value, callback) => {
      if (value.length != 6) {
        callback(new Error("请输入短信验证码"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      var reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\S]{8,16}$/;
      if (value.length < 8 || value.length > 16) {
        callback(new Error("密码需为8～16位大小字母、数字组合"));
      } else if (!reg.test(value)) {
        callback(new Error("密码需为8～16位大小字母、数字组合"));
      } else {
        callback();
      }
    };
    return {
      agreeCancelBool: false,
      prevText: "坚持去注销",
      tipPass1: true,
      tipPass2: false,
      tipPass3: false,
      show: true,
      able: false,
      whiteLikeAble: false,
      blueLikeAble:false,
      timer: null,
      count: "",
      cancelAccForm: {
        phoneCode: ""
      },
      cancelAccFormRules: {
        phoneCode: [
          { required: true, trigger: "blur", validator: validatePhoneCode }
        ]
      }
    };
  },
  props: {
    userInfo: {
      type: Object,
      default: {}
    }
  },
  computed: {},
  watch: {},
  methods: {
    getCode() {
      user
        .cancelAccCheck(this.userInfo.mobile)
        .then(response => {
          // this.$Message.success(response.data.message);
        })
        .catch(error => {
          console.log(error);
        });
      // 发送请求获取验证码
      this.able = true;
      // 倒计时
      const TIME_COUNT = 90;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            this.able = false;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    handCheckCode() {
      this.$refs.cancelAccForm.validateField("phoneCode", valid => {
        if (!valid) {
          user
            .cancelAcc({
              mobile: this.userInfo.mobile,
              mobile_verify_code: this.cancelAccForm.phoneCode
            })
            .then(response => {
              // this.$Message.success(response.data.message);
              this.tipPass3 = true;
              setTimeout(() => {
                location.href = "http://www.huanqiu.com";
              }, 3000);
            })
            .catch(error => {
              if(error.data.errors.mobile_verify_code[0] === '验证码错误'){
                this.$Message({ message: '验证码错误', type: "warning" });
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    prevFn() {
      if (this.whiteLikeAble) {
        return;
      }
      if (this.tipPass1 && this.tipPass2 && !this.tipPass3) {
        this.prevText = "坚持去注销";
        this.tipPass2 = false;
      }
    },
    nextFn() {
      if (this.blueLikeAble) {
        return
      }
      if (this.tipPass1 && !this.tipPass2) {
        // this.handCheckCode();
        if (this.agreeCancelBool) {
          this.prevText = "下一步";
          this.tipPass2 = true;
        } else {
          if (document.getElementsByClassName("el-message").length === 0) {
            this.$Message.info("请阅读并确认后勾选状态");
          }
        }
      } else if (this.tipPass1 && this.tipPass2 && !this.tipPass3) {
        this.handCheckCode();
      }
    }
  },
  created() {},
  mounted() {},
  beforeCreate() {}
};
</script>
<style lang='scss' scoped>
.cancelAcc {
  position: relative;
  .cancelAcc-tips {
    width: 640px;
    margin: 30px 40px 0;
    border-bottom: 1px solid #e5e5e5;
    .title {
      color: #4c4c4c;
      font-family: Microsoft YaHei;
      font-weight: 700;
      font-size: 20px;
      line-height: 40px;
      letter-spacing: 0px;
      text-align: left;
      padding-left: 51px;
      position: relative;
      .under_line {
        width: 60px;
        height: 3px;
        position: absolute;
        bottom: 0;
        left: 60px;
        background-color: orange;
      }
    }
  }
  .cancelAcc_content {
    width: 400px;
    height: 260px;
    border-radius: 6px;
    background: #f3f2f0;
    position: absolute;
    left: 165px;
    top: 150px;
    .cancelAcc_logo {
      width: 112px;
      height: 112px;
      position: absolute;
      top: -56px;
      left: 144px;
      display: inline-block;
      background: url("../../../assets/images/icon-3.png") no-repeat center;
    }
    .change-Part {
      margin-top: 70px;
      .step1 {
        .step1-tips-title {
          color: #4d4d4d;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 22px;
          line-height: normal;
          letter-spacing: 0px;
          text-align: center;
          margin-bottom: 23px;
        }
        .step1-tips-content {
          border-top: 1px dashed #aba08b;
          padding: 10px 0;
          margin: 0 50px;
          color: #4c4c4c;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          line-height: 26px;
          letter-spacing: 0px;
          text-align: left;
        }
        .agreeCancel {
          color: #333333;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          line-height: 26px;
          letter-spacing: 0px;
          text-align: left;
          padding-left: 21px;
          position: relative;
          .agree-icon {
            width: 14px;
            height: 14px;
            display: inline-block;
            position: absolute;
            left: 0;
            top: 16px;
            cursor: pointer;
            background: url("../../../assets/images/icons.png") no-repeat -50px -20px;
          }
          .agreeTrue {
            background: url("../../../assets/images/icons.png") no-repeat -20px -20px;
          }
        }
      }
      .step2 {
        overflow: hidden;
        .step2-tips {
          color: #999999;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          line-height: normal;
          letter-spacing: 0px;
          text-align: center;
          margin-top: 9px;
        }
        .phone {
          color: #000000;
          font-family: Verdana;
          font-weight: 400;
          font-size: 18px;
          line-height: normal;
          letter-spacing: 0px;
          text-align: center;
        }
        .check-phonecode-div {
          margin-top: 30px;
          margin-left: 70px;
          width: 150px;
          position: relative;
          .el-input {
            width: 148px;
            .el-input__inner {
              height: 42px;
              line-height: 42px;
            }
          }
          .el-button.codeBtn {
            width: 100px;
            height: 40px;
            position: absolute;
            right: -110px;
            top: 0;
            padding: 0;
            color: #fff;
            border-radius: 6px;
            background: #4981f2;
            box-shadow: inset 0px -3px 0px 0 #3f79ee, 0px 2px 0px 0 #e5e5e5;
          }
        }
      }
      .step3 {
        .step3-tips {
          color: #999999;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          line-height: normal;
          letter-spacing: 0px;
          text-align: center;
        }
        .new_phone {
          color: #000000;
          font-family: Verdana;
          font-weight: 400;
          font-size: 18px;
          line-height: normal;
          letter-spacing: 0px;
          text-align: center;
        }
        .check-newphonecode-div {
          margin-top: 30px;
          margin-left: 70px;
          width: 260px;
          position: relative;
          .el-form-item {
            margin-bottom: 10px;
          }
          .el-input {
            width: 258px;
            .el-input__inner {
              height: 42px;
              line-height: 42px;
            }
          }
        }
        .againSendMsg-div {
          color: #999999;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          letter-spacing: 0px;
          text-align: right;
          .againSendMsg {
            color: #4981f2;
            cursor: pointer;
          }
        }
      }
    }
    .cancelAcc_control {
      position: absolute;
      bottom: -14px;
      left: 55px;
      height: 28px;
      span {
        cursor: pointer;
        width: 128px;
        height: 28px;
        margin: 0 6px;
        border-radius: 14px;
        display: inline-block;
        text-align: center;
        color: #4981f2;
        font-family: Microsoft YaHei;
        line-height: 28px;
        font-size: 14px;
        letter-spacing: 0px;
        background: #ffffff;
        border: 1px solid #4981f2;
        box-shadow: inset 0px -2px 0px 0 #cccccc, 0px 2px 0px 0 #e5e5e5;
      }
      .next-step {
        color: #ffffff;
        background: #4981f2;
        box-shadow: inset 0px -3px 0px 0 #3f79ee, 0px 2px 0px 0 #e5e5e5;
      }
    }
    .cancelAcc_control.beginEdit {
      right: 71px;
      text-align: right;
    }
  }
  .bigerContent {
    width: 560px;
    height: 380px;
    left: 80px;
    top: 150px;
    .cancelAcc_logo {
      left: 224px;
    }
  }
  .step3 {
    height: 234px;
    width: 200px;
    position: absolute;
    left: 260px;
    top: 125px;
    .success-logo {
      width: 170px;
      height: 170px;
      display: inline-block;
      background: url("../../../assets/images/icon-3a.png") no-repeat center;
      margin-left: 15px;
    }
    .success-tips {
      .success-title {
        margin-top: 10px;
        color: #000;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 22px;
        line-height: normal;
        letter-spacing: 0px;
        text-align: center;
        margin-bottom: 6px;
      }
      .success-jump {
        text-align: center;
        .backIndex {
          color: #316de6;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          line-height: normal;
          letter-spacing: 0px;
          text-align: center;
          text-decoration: none;
        }
      }
      .success-thanks {
        margin-top: 44px;
        color: #333333;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0px;
        text-align: center;
        width: 214px;
        height: 40px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/index/safetyCenter/cancelAcc.vue